const initialStateFetch = {
  pictures: [],
  loading: false
};

export function fetchPictures(state = initialStateFetch, action) {
  switch (action.type) {
    case 'FETCH_PICTURES.SUCCESS':
    case 'SAVE_PICTURES.SUCCESS':
      return {
        ...state,
        pictures:  action.pictures.body
      };
    default:
      return state;
  }
}
